import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

const ArticleSchema = ({ post, thumbnail }) => {
  const { site, logo } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            author {
              name
              summary
            }
            description
            defaultImage
            social {
              twitter
            }
            siteUrl
            ogCard
          }
        }
        logo: file(relativePath: { in: "poppo1.png" }) {
          childImageSharp {
            fluid {
              src
            }
          }
        }
      }
    `
  )
  const siteUrl = site.siteMetadata?.siteUrl
  const name = site.siteMetadata?.author.name
  const summary = site.siteMetadata?.author.summary

  const imagePath = thumbnail
    ? `${siteUrl}${thumbnail.childImageSharp.gatsbyImageData.images.fallback.src}`
    : `${siteUrl}{defaultImage}`

  const logoPath = logo
    ? `${siteUrl}${logo.childImageSharp.fluid.src}`
    : `${siteUrl}{defaultImage}`

  const schema = {
    "@context": "http://schema.org",
    "@type": "Article",
    name: post.frontmatter.title,
    headline: post.frontmatter.title,
    author: {
      "@type": "Person",
      name: name,
      description: summary,
    },
    image: {
      "@type": "ImageObject",
      url: imagePath,
    },
    description: post.frontmatter.description,
    url: siteUrl + post.fields.slug,
    mainEntityOfPage: siteUrl + post.fields.slug,
    publisher: {
      "@type": "Person",
      name: site.siteMetadata?.author.name,
      description: summary,
      logo: {
        "@type": "ImageObject",
        url: logoPath,
      },
    },
    datePublished: post.frontmatter.date,
    dateModified: post.frontmatter.rewrite,
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}

export default ArticleSchema
